import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import type { SessionKind } from '../api/SessionKind';
import { ErrorNotice } from '../components/ErrorNotice';

import { FullPageSpinner } from './FullPageSpinner';
import { homeOf } from './home';
import { useSession } from './SessionContext';

/**
 * Renders its children only for a session of the given kind. A business user who types a platform URL is
 * sent to their own home rather than shown a screen that would answer 403 (Conventions/06 §2).
 */
export const RequireSession = ({ kind, children }: { kind: SessionKind; children: ReactNode }) => {
  const { profile, isLoading, error, retry } = useSession();

  if (isLoading) {
    return <FullPageSpinner />;
  }

  if (!profile) {
    return error ? (
      <Box sx={{ p: 4 }}>
        <ErrorNotice error={error} onRetry={retry} />
      </Box>
    ) : (
      <Navigate to="/login" replace />
    );
  }

  if (profile.kind !== kind) {
    return <Navigate to={homeOf(profile.kind)} replace />;
  }

  return <>{children}</>;
};
